<template>
  <Modal 
    :actionButtons="actionButtons">
    <template #header>
      <div
        class="tw-flex-auto headlines--headline-06 tw-text-core-primary-10 tw-p-4"
        data-test="password-reset-callout-title">
        {{ t('common.messages.password_reset_callout_title') }}
      </div>
    </template>
    <template #body>
      <div>
        <img
          :src="require('../../../assets/images/reset_icon.svg')"
          alt="Reset icon"
          class="center-block">
        <div
          class="tw-mt-4"
          data-test="password-reset-callout-message">
          {{ t('common.messages.password_reset_callout_message') }}
        </div>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import i18n from 'frontcore/i18n'
import Modal from 'frontcore/components/Modal.vue'
import { AuthorizationStorageFactory } from 'frontcore/domain/authorization/store/factory'
import { computed, onMounted } from 'vue'

interface Props {
  userId: number
}
const props = defineProps<Props>()

const { t } = i18n.global

const storage = AuthorizationStorageFactory.build()

onMounted(() => {
  storage.clear()
})

const redirect = () => {
  const url = `${MPS_URL}/update-password/?user=${props.userId}&continue=${window.location}`
  window.location.assign(url)
}

const actionButtons = computed(() => {
  return [
    {
      label: t('common.messages.password_reset_callout_button'),
      onClickHandler: redirect,
      dataTest: 'password-reset-callout-redirect-button',
    },
  ]
})

</script>
